import React, { MouseEventHandler, ReactNode } from 'react';

interface Props {
  className?: string;
  type?: 'submit' | 'reset' | 'button';
  component: string;
  disabled?: boolean;
  form?: string;
  color?: string;
  onClick?: MouseEventHandler;
  children: ReactNode;
}

const MainButton = ({
  className = '',
  type = 'button',
  form = '',
  color = 'blue',
  children,
  onClick,
  component = '',
  disabled,
}: Props) => {
  if (component === 'button') {
    return (
      <button
        className={`main-button main-button-${color} ${className}`}
        type={type}
        form={form}
        disabled={disabled}
        onClick={onClick}
        tabIndex={0}
      >
        <span className="main-button-label">{children}</span>
      </button>
    );
  }

  return (
    <span
      className={`main-button main-button-${color} ${className} ${disabled ? 'disabled' : ''}`}
      onClick={onClick}
      tabIndex={0}
    >
      <span className="main-button-label">{children}</span>
    </span>
  );
};

export default MainButton;
